import React from 'react';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export const ToastMessage = () => {
  return <ToastContainer />;
};

export const Toast = (message, config) => {
  toast(message, config);
};

export const toastMsgConfig = (type) => {
  const config = {
    position: 'top-right',
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
  };

  switch(type) {
    case 's':
      return { ...config, type: 'success' };
    case 'e':
      return { ...config, type: 'error' };
    case 'w':
      return { ...config, type: 'warning' };
    case 'i':
      return { ...config, type: 'info' };
    default:
      return { ...config, type: 'default' };
  }
};
